import gql from 'graphql-tag';

export const getIntercomMessengerAuth = gql`
  query getIntercomMessengerAuth($channelId: UUID!) {
    intercomMessengerAuth(channelId: $channelId) {
      channelId
      appId
      intercomUserJwt
      intercomUserJwtExpiresAt
      androidApiKey
      iosApiKey
    }
  }
`;
